//import { create as gallery } from './gallery';
import { create as slideshows } from "./slideshows";
import { create as lightbox } from "./lightbox";

export function init() {
	const galleryElement = document.querySelector(".c-boat-slideshow");
	const lightboxElement = document.querySelector(".js-boat-lightbox");

	createGallery();

	function createGallery() {
		if (!galleryElement) {
			return;
		}

		const galleryInstance = slideshows(galleryElement);
		const lightboxInstance = lightbox(lightboxElement);

		if (!galleryInstance) {
			return;
		}

		galleryInstance.on(
			"staticClick",
			function handleClick(event, pointer, cellElement, cellIndex) {
				if (cellIndex === undefined) {
					return;
				}

				lightboxInstance.open(cellIndex);
			},
		);
	}

  const print = document.querySelector(".print-page");

  if (print) {
    print.addEventListener('click', (event) => {
      window.print();
    });
  }
}
